import React from 'react';
import './Player.css';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';  //import bootstrap.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; //import font Awesome icon.
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

//Receive Player information from player data by props.
const Player = (props) => {
    const {name,salary,img} = props.player;
    const handleAdded=props.addEventHandler;
    return (
        // Display all information of a player Dynamically and set a event handler.
        <div className="player-container text-center">  {/* Using bootstrap class. */}
            <h2>Name: {name}</h2>
            <h4>Salary: {salary}</h4>
            <img src={img} alt=""/>
            <button onClick={()=>handleAdded(props.player)} className="mt-3 btn btn-primary"><FontAwesomeIcon icon={faUserPlus} />  Add Player</button> {/* Using bootstrap class and Font Awesome icon */}
        </div>
    );
};

export default Player;